const DeleteDraftButton = ({ onClick }) => {
  return (
    <div
      className="artwork-drafts__remove-draft-button "
      onClick={onClick}
      
    >
      <div />
    </div>
  );
};

export default DeleteDraftButton;
